module.exports = __webpack_public_path__ + "img/customerLogo6.a4d1c710.png";